'use client';

import { Box } from '@mui/material';
import type { StateAbbreviation } from '@repo/supergraph/marketplace/types';
import { snakeCase } from 'lodash';
import { useRef } from 'react';
import { DesktopFilters } from '../components/OffersFilter/DesktopFilterBar';
import { DesktopFiltersWithGeo } from '../components/OffersFilter/DesktopFilterBar/DesktopFiltersWithGeo';
import { MobileFilters, MobileFiltersWithGeo } from '../components/OffersFilter/MobileFilters';

type Props = {
  slug: string;
  initialLocation?: StateAbbreviation;
  children: React.ReactNode;
};

export function HYSAInlineFilterBar({ slug, initialLocation, children }: Props) {
  const filteredProductsRef = useRef<HTMLDivElement>(null);
  const snakeCasedSlug = snakeCase(slug);
  const analyticsProps = {
    actionSection: `banking_${snakeCasedSlug}_filter`,
    pageIdentifier: snakeCasedSlug,
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'space-between',
          alignItems: { xs: 'flex-start', md: 'center' },
          gap: 2,
          maxWidth: { xs: '100%', md: '82%' },
          marginX: 'auto',
        }}
      >
        {initialLocation ? (
          <DesktopFiltersWithGeo
            mainSectionRef={filteredProductsRef}
            slug={slug}
            initialLocation={initialLocation}
            analyticsProps={analyticsProps}
          />
        ) : (
          <DesktopFilters
            mainSectionRef={filteredProductsRef}
            slug={slug}
            analyticsProps={analyticsProps}
          />
        )}
      </Box>
      {initialLocation ? (
        <MobileFiltersWithGeo
          slug={slug}
          initialLocation={initialLocation}
          analyticsProps={analyticsProps}
        />
      ) : (
        <MobileFilters slug={slug} initialLocation={initialLocation} analyticsProps={analyticsProps} />
      )}
      <Box ref={filteredProductsRef}>{children}</Box>
    </>
  );
}
